import {
  PORTFOLIO_ALL,
  PORTFOLIO_GET,
  PORTFOLIO_PUT,
  PORTFOLIO_DEL,
  PORTFOLIO_POST,
  PORTFOLIO_LOADING,
  PORTFOLIO_ERROR,
} from '../../actions/types';

const initialState = {
  portfolio: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PORTFOLIO_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PORTFOLIO_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PORTFOLIO_POST:
      return { isLoading: true, isCompleted: true };
    case PORTFOLIO_PUT:
      return { isLoading: false, isCompleted: true };
    case PORTFOLIO_DEL:
      return { isLoading: false, isCompleted: true };
    case PORTFOLIO_LOADING:
      return { isLoading: true, isCompleted: true };
    case PORTFOLIO_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
